import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  TextField,
  Select,
  MenuItem,
  IconButton,
} from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import DashboardIcon from '@mui/icons-material/Dashboard';
import { getAllUsers, getDashboardData } from '../api/dashboard';
import moment from 'moment';

const Dashboard = () => {
  const [activityFilter, setActivityFilter] = useState('all');
  const [userData, setUserData] = useState([]); 
  const [dashboardData, setDashboardData] = useState({
    total_users: 0,
    total_active_users: 0,
    total_inactive_users: 0,
  });
  const [searchQuery, setSearchQuery] = useState('');

  const fetchDashboardData = async () => {
    try {
      const response = await getDashboardData();
      setDashboardData(response.data);
    } catch (error) {
      console.error('Error fetching dashboard data:', error);
    }
  };

  const fetchAllUsers = async (searchTerm = '', status = '') => {
    try {
      const response = await getAllUsers(searchTerm, 0, 100, status);
      setUserData(response.data);
    } catch (error) {
      console.error('Error fetching user data:', error);
    }
  };

  useEffect(() => {
    fetchDashboardData();
    fetchAllUsers('', activityFilter);
  }, [activityFilter]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      fetchAllUsers(searchQuery, activityFilter);
    }, 500);

    return () => clearTimeout(timeoutId);
  }, [searchQuery, activityFilter]);

  return (
    <Box sx={{ padding: 3, flexGrow: 1, height: '90vh', overflow: 'auto' }}>
      <Box
        sx={{
          paddingLeft: '10px',
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          marginBottom: 2,
          height: '80px',
          backgroundColor: '#FFF',
          boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
        }}
      >
        <DashboardIcon sx={{ fontSize: 28, color: '#333' }} />
        <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
          Dashboard
        </Typography>
      </Box>

      <Box
        style={{
          backgroundColor: '#FFF',
          boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
          padding: '20px',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '20px',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Select
              value={activityFilter}
              onChange={(e) => setActivityFilter(e.target.value)}
              variant="outlined"
              size="small"
              sx={{ minWidth: 150 }}
            >
              <MenuItem value="all">All Users</MenuItem>
              <MenuItem value="active">Active Users</MenuItem>
              <MenuItem value="inactive">Inactive Users</MenuItem>
            </Select>
            {activityFilter !== 'all' && (
              <Button
                variant="outlined"
                size="small"
                onClick={() => {
                  setActivityFilter('all');
                  setSearchQuery('');
                }}
                sx={{ minWidth: 100 }}
              >
                Clear Filter
              </Button>
            )}
            <IconButton>
              <FilterListIcon />
            </IconButton>
          </Box>

          <TextField
            placeholder="Search ..."
            variant="outlined"
            size="small"
            sx={{ width: 250 }}
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </Box>

        <Grid container spacing={3} sx={{ marginBottom: 3 }}>
          <Grid item xs={4}>
            <Paper sx={{ padding: 2, textAlign: 'center' }}>
              <Typography variant="h6">Total Users</Typography>
              <Typography variant="h4">{dashboardData.total_users}</Typography>
            </Paper>
          </Grid>
          <Grid item xs={4}>
            <Paper sx={{ padding: 2, textAlign: 'center' }}>
              <Typography variant="h6">Active Users</Typography>
              <Typography variant="h4">{dashboardData.total_active_users}</Typography>
            </Paper>
          </Grid>
          <Grid item xs={4}>
            <Paper sx={{ padding: 2, textAlign: 'center' }}>
              <Typography variant="h6">Inactive Users</Typography>
              <Typography variant="h4">{dashboardData.total_inactive_users}</Typography>
            </Paper>
          </Grid>
        </Grid>

        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }}>
            <TableHead>
              <TableRow>
                <TableCell>User Name</TableCell>
                <TableCell>Joining Date</TableCell>
                <TableCell>Email ID</TableCell>
                <TableCell>Status</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {userData.map((user, index) => (
                <TableRow key={index}>
                  <TableCell>{user.name}</TableCell>
                  <TableCell>{moment(user.created_at).format('MMM DD, YYYY')}</TableCell>
                  <TableCell>{user.email}</TableCell>
                  <TableCell
                    sx={{ 
                      color: user.is_active ? 
                        (moment().diff(moment(user.last_login_at), 'days') > 7 ? 'red' : 'green') 
                        : 'red' 
                    }}
                  >
                   {`${user.is_active ? 'Active' : 'Inactive'} ${moment(user.last_login_at).fromNow()}`}
                  </TableCell>
                </TableRow>
              ))}
              {userData.length === 0 && (
                <TableRow>
                  <TableCell colSpan={4} align="center">
                    No users found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  );
};

export default Dashboard;
